export function generateGridFilteredRows(rows, filters) {
  const containsCols = new Set([
    "producer_codes",
    "saleinvoicenumbers",
    "edivalidationerrors",
    "edicomparisonerror",
    "paymentcolumn",
    "portdistcharge_code_special",
    "defects",
    "discharge_ports",
  ]);

  const filterKeys = Object.keys(filters);

  const processedFilters = {};
  for (const col of filterKeys) {
    const terms = filters[col].filterTerm || [];

    if (col === "ata") {
      processedFilters[col] = {
        type: "ata",
        blanks: new Set("BLANK"),
        exact: new Set(terms.filter((t) => t.label !== "BLANK").map((t) => (t.value || "").toString().trim())),
      };
      continue;
    }

    if (containsCols.has(col)) {
      processedFilters[col] = {
        type: "contains",
        blanks: new Set(""),
        containsValues: terms.filter((t) => t.label !== "BLANK").map((t) => (t.value || "").toString().trim()),
      };
      continue;
    }

    processedFilters[col] = {
      type: "exact",
      exact: new Set(terms.map((t) => (t.value || "").toString().trim())),
    };
  }

  return rows.filter((row) => {
    return filterKeys.every((col) => {
      const rowVal = (row[col] || "").toString().trim();
      const filter = processedFilters[col];

      switch (filter.type) {
        case "contains":
          if (filter.blanks.has("") && rowVal === "") {
            return true;
          }
          if (filter.containsValues.length) {
            return filter.containsValues.some((val) => rowVal.toLowerCase().includes(val.toLowerCase().trim()));
          }
          return false;
        case "ata":
          if (filter.blanks.has(rowVal) || rowVal.includes("1900-01-01T00:00:00.000Z")) {
            return true;
          }
          return filter.exact.has(rowVal);
        case "exact":
          return filter.exact.has(rowVal);
        default:
          return true;
      }
    });
  });
}
